export const FILTER_NAME_ATTRIBUTE_MAP = [
    { Markdown: 'filter.p.m.custom.discount_bucket' },
    { Size: 'filter.v.option.size' },
    { Type: 'filter.p.m.custom.l3_product_type' },
    { Purpose: 'filter.p.m.custom.purpose' },
    { Gender: 'filter.p.m.custom.gender_multiselect' },
    { Colour: 'filter.p.m.custom.colour_family_1' },
    { Collection: 'filter.p.m.custom.maap_range' },
    { Fit: 'filter.p.m.custom.maap_fit' },
    { Season: 'filter.p.m.custom.season' },
    { Length: 'filter.p.m.custom.length_attribute' },
];
